export const Strings_DE = {
  thwaitesglacier: 'Thwaites-Gletscher',
  antarctica: 'Antarktis',
  southpole: 'Südpol',
  southamerica: 'Südamerika',
  weddelsea: 'Weddellmeer',
  rossea: 'Rossmeer',
  belowsealevel: (
    <>
      Grosse Teile der west&shy;antarktischen Land&shy;masse liegen unterhalb des
      Meeres&shy;spiegels.
    </>
  ),
  titleB: 'Höhenprofil der Antarktis',
}
